export interface FormValues {
  name: string;
  comments: string;
}
export default function mapPropsToValues() {
  return {
    name: "",
    comments: "",
  };
}